// Compact facet filter dropdown for NMT planning dimensions

import type { GraphFacetOption } from "../types/graph";

interface DomainFacetSelectProps {
  label: string;
  options: GraphFacetOption[];
  selected: string[];
  onChange: (next: string[]) => void;
}

export default function DomainFacetSelect({
  label,
  options,
  selected,
  onChange,
}: DomainFacetSelectProps) {
  if (!options.length) return null;

  return (
    <label className="flex items-center gap-1.5 text-xs text-fl-sand-80">
      <span className="whitespace-nowrap">{label}</span>
      <select
        value={selected[0] ?? ""}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v ? [v] : []);
        }}
        className="max-w-[140px] truncate rounded border border-fl-forest/60 bg-fl-forest/30 px-1.5 py-0.5 text-xs text-white"
      >
        <option value="">All</option>
        {options.map((o) => (
          <option key={o.name} value={o.name}>
            {o.name} ({o.count})
          </option>
        ))}
      </select>
    </label>
  );
}
